import { MonetaryAmount } from '@generated-types';

export const formatPhoneNumber = (phoneNumber: string) => {
    if (phoneNumber.length !== 8) {
        return phoneNumber;
    }

    const [a, b, c, d, e, f, g, h] = phoneNumber;
    return `${a}${b}${c} ${d}${e} ${f}${g}${h}`;
};

interface Options {
    maximumFractionDigits?: number;
    currencyCode?: string;
}

export const formatAmount = (value: number | undefined, options: Options = {}): string => {
    const { maximumFractionDigits = 2, currencyCode = 'NOK' } = options;
    if (typeof value === 'undefined') {
        return '';
    }

    let minimumFractionDigits = 0;

    if (maximumFractionDigits >= 2) {
        minimumFractionDigits = 2;
    }

    const nf = new Intl.NumberFormat('no-NO', { minimumFractionDigits, maximumFractionDigits });
    const numberDisplay = nf.format(value);

    if (currencyCode === 'NOK') {
        return `${numberDisplay} kr`;
    }

    return numberDisplay;
};

export const prettyMonetary = (monetaryAmount: MonetaryAmount) =>
    formatAmount(monetaryAmount.amount, { currencyCode: monetaryAmount.currency, maximumFractionDigits: 0 });

export interface Validation {
    result: boolean;
    message: string;
}

export const sanitizeNumericValue = (value: string): string => value.replace(/[\s.]+/g, '');
